import React from "react";
import BlogThirtyFive from "../component/BlogThirtyFive";

function BlogThirtyFiveContainer() {
  return <BlogThirtyFive />;
}
export default BlogThirtyFiveContainer;
